var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 17",
    style: {
      enableBackground: "new 0 0 15 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1075 -406 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1080.4,412.5c0.1,0.1,0.1,0.2,0.1,0.3v6.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.2,0.1h-0.7 c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-6.4c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.2-0.1h0.7 C1080.2,412.4,1080.3,412.4,1080.4,412.5z M1083.1,412.5c0.1,0.1,0.1,0.2,0.1,0.3v6.4c0,0.1,0,0.2-0.1,0.3s-0.1,0.1-0.2,0.1h-0.7 c-0.1,0-0.2,0-0.2-0.1s-0.1-0.2-0.1-0.3v-6.4c0-0.1,0-0.2,0.1-0.3s0.1-0.1,0.2-0.1h0.7C1082.9,412.4,1083,412.4,1083.1,412.5z  M1085.8,412.5c0.1,0.1,0.1,0.2,0.1,0.3v6.4c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.2,0.1h-0.7c-0.1,0-0.2,0-0.2-0.1 c-0.1-0.1-0.1-0.2-0.1-0.3v-6.4c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.2-0.1h0.7C1085.7,412.4,1085.7,412.4,1085.8,412.5z  M1087.2,421.2c0-0.1,0.1-0.3-0.2-0.4v-10.5h-9v10.5c-0.3,0.2-0.2,0.3-0.2,0.4c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.1,0.1,0.1h8.9 c0,0,0.1,0,0.1-0.1C1087.1,421.4,1087.1,421.3,1087.2,421.2z M1080.6,407.5l-0.5,1.3h4.8l-0.5-1.3c0-0.1-0.1-0.1-0.2-0.1h-3.4 C1080.7,407.4,1080.7,407.5,1080.6,407.5z M1089.9,408.9c0.1,0.1,0.1,0.2,0.1,0.3v0.7c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.1,0.1-0.2,0.1h-1v10.5c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.4-0.7,0.7-1.2,0.7h-8.9c-0.5,0-0.9-0.2-1.2-0.6 c-0.3-0.4-0.5-1-0.5-1.6v-10.5h-1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-0.7c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.1-0.1,0.2-0.1h3.3l0.7-1.8c0.1-0.3,0.3-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.8-0.3h3.4c0.3,0,0.6,0.1,0.8,0.3 c0.3,0.2,0.5,0.4,0.6,0.7l0.7,1.8h3.3C1089.8,408.8,1089.8,408.9,1089.9,408.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d8734666c0a1b834c933f19658b1a36c.svg";
export { ForwardRef as ReactComponent };